import React, { useState, useEffect } from 'react';
import { FaTags } from 'react-icons/fa';
import axios from 'axios';
import '../styles/TagFilter.css';

const API = process.env.REACT_APP_API_URL || '';

function TagFilter({ onTagSelect, selectedTag }) {
  const [tags, setTags] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    loadTags();
  }, []);

  const loadTags = async () => {
    try {
      const res = await axios.get(`${API}/api/tags`);
      setTags(res.data);
    } catch (e) { /* ignore */ }
  };

  const grouped = tags.reduce((acc, t) => {
    if (!acc[t.category]) acc[t.category] = [];
    acc[t.category].push(t);
    return acc;
  }, {});

  const categoryLabels = { mood: '🎭 Ambiances', theme: '🎬 Thèmes', era: '🏰 Époques', season: '🎄 Saisons' };

  if (tags.length === 0) return null;

  return (
    <div className="tag-filter">
      <button className="tag-filter-toggle" onClick={() => setExpanded(!expanded)}>
        <FaTags /> Filtrer par ambiance
        {selectedTag && <span className="tag-active-indicator">•</span>}
      </button>

      {expanded && (
        <div className="tag-filter-panel">
          {selectedTag && (
            <button className="tag-clear" onClick={() => onTagSelect(null)}>✕ Effacer le filtre</button>
          )}
          {Object.entries(grouped).map(([cat, catTags]) => (
            <div key={cat} className="tag-category">
              <div className="tag-cat-label">{categoryLabels[cat] || cat}</div>
              <div className="tag-list">
                {catTags.map(t => (
                  <button key={t.id}
                    className={`tag-chip ${selectedTag === t.id ? 'selected' : ''}`}
                    style={{ '--tag-color': t.color }}
                    onClick={() => onTagSelect(selectedTag === t.id ? null : t.id)}>
                    {t.name}
                    {t.album_count > 0 && <span className="tag-count">{t.album_count}</span>}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TagFilter;
